var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDragDropDots = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 6,
  r: 1.5,
  fill: "#fff",
  fillOpacity: 0.25
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 13,
  r: 1.5,
  fill: "#fff",
  fillOpacity: 0.25
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 20,
  r: 1.5,
  fill: "#fff",
  fillOpacity: 0.25
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 6,
  r: 1.5,
  fill: "#fff",
  fillOpacity: 0.25
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 13,
  r: 1.5,
  fill: "#fff",
  fillOpacity: 0.25
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 20,
  r: 1.5,
  fill: "#fff",
  fillOpacity: 0.25
})));
SvgDragDropDots.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragDropDots);
export default ForwardRef;